// src/api/axios.js
import axios from "axios";
import {
  getAuthToken,
  clearAuthSession,
  updateActivityTimestamp,
} from "./authSession";

// Central API Base URL - reads from environment variable or defaults to backend URL
export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || "https://blog.dietchapter.hosting.acm.org"
).replace(/\/+$/, "");

// Central Axios client
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor: automatically attach JWT token if present
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: track activity on API success and auto-logout on 401
api.interceptors.response.use(
  (response) => {
    updateActivityTimestamp();
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      clearAuthSession();
      if (window.location.pathname !== "/login") {
        alert("🔒 Session expired or unauthorized. Please log in again.");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Utility helper to format image and media URLs consistently across the project
 * @param {string} path - Relative or absolute image path
 * @returns {string} Formatted full URL
 */
export const getImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  const cleanPath = path.replace(/\\/g, "/").replace(/^\/+/, "");
  return `${API_BASE_URL}/${cleanPath}`;
};

export default api;
